import { createContext, useContext, type ReactNode } from "react";
import type {
  HumanInTheLoopActionRequest,
  HumanInTheLoopDecision,
  HumanInTheLoopRequest,
} from "./human-in-the-loop";

export type HumanInTheLoopContextValue = {
  request: HumanInTheLoopRequest;
  decisions: (HumanInTheLoopDecision | undefined)[];
  setDecision: (index: number, decision: HumanInTheLoopDecision) => void;
  isLoading: boolean;
};

const HumanInTheLoopContext = createContext<HumanInTheLoopContextValue | null>(
  null
);
export const HumanInTheLoopProvider = HumanInTheLoopContext.Provider;
export const useHumanInTheLoop = () => useContext(HumanInTheLoopContext);

const PendingTranscriptToolCallsContext = createContext<
  HumanInTheLoopActionRequest[]
>([]);

export const PendingTranscriptToolCallsProvider = ({
  actions,
  children,
}: {
  actions: HumanInTheLoopActionRequest[];
  children: ReactNode;
}) => (
  <PendingTranscriptToolCallsContext.Provider value={actions}>
    {children}
  </PendingTranscriptToolCallsContext.Provider>
);

export const usePendingTranscriptToolCalls = () =>
  useContext(PendingTranscriptToolCallsContext);
